var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":"user-pwd"}},[_c('TerminalReadOnly',{attrs:{"readOnlyText":`${_vm.username}@${_vm.sysname}:${_vm.pwd}>`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }